import clsx from "clsx";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import styles from "./Checkboxes.module.scss";

interface ICheckboxes {
  children: React.ReactNode;
  errorMessage?: string;
  icon?: React.ReactNode;
  legend?: string;
  orientation?: "vertical" | "horizontal";
  width?: "hug-content" | "fill-container";
}
const Checkboxes = ({
  children,
  errorMessage,
  icon,
  legend,
  orientation = "vertical",
  width = "hug-content",
}: ICheckboxes) => {
  return (
    <fieldset className={styles.checkboxesFieldset}>
      {icon || legend ? (
        <legend className={styles.legend}>
          {icon}
          {legend}
        </legend>
      ) : undefined}
      {errorMessage ? (
        <div className={styles.errorMessage}>
          <ErrorMessage message={errorMessage} weight="bold" />
        </div>
      ) : undefined}
      <div
        className={clsx(
          styles.checkboxes,
          styles[orientation],
          styles[`width-${width}`],
        )}
      >
        {children}
      </div>
    </fieldset>
  );
};

export default Checkboxes;
